import { useEffect, useState } from "react";
import ReactTableComponent from "../../UniversalComponents/ReactTableComponent";
import ToolTipComponent from "../../UniversalComponents/ToolTipComponent";
import PlusIcon from "../../../assets/images/icons/PlusIcon";
import CustomDrawer from "../../UniversalComponents/CustomDrawer";
import { ReactComponent as CrossIcon } from "../../../assets/images/CrossIconCreateGroup.svg";
import Button from "../../UniversalComponents/DefaultButton";
import LabelComponent from "../../UniversalComponents/LabelComponent";
import BasicSelect from "../../Task/BasicSelect";
import InputComponent from "../../UniversalComponents/InputComponent";
import useCustomFormValidation from "../../../hooks/ErrorHandling/useCustomFormValidation";
import {
  addUpdateGroup,
  deleteGroup,
  deleteGroupPermission,
  fetchManagePermission,
} from "../../../utils/api/managePermissionApi";
import { getCompanyId } from "../../../utils/utilityFunctions/localServices";
import DeleteIcon from "../../../assets/images/icons/deleteIcon";
import { pushAlert } from "../../../utils/alertSlice";
import { useDispatch } from "react-redux";
import ConfirmationDialogBox from "../../UniversalComponents/ConfirmationDialogMulti";
import PermissionModuleOptions from "./PermissionModuleOptions";
import { ReactComponent as PencilIcon } from "../../../assets/images/pencilIcon.svg";
import EditGroupMember from "../EditGroupMember";
import { ReactComponent as BackArrow } from "../../../assets/images/icons/BackIcon.svg";
import { hideLoader, showLoader } from "../../../utils/loaderSlice";
import { ReactComponent as NoGroup } from "../../../assets/images/NoGroup.svg";
import SelectComponent from "../../UniversalComponents/SelectComponent";
import { useParams } from "react-router-dom";
const Group = ({ TabSwitch }) => {
  const [isGroupDrawerOpen, setIsGroupDrawerOpen] = useState(false);
  const [isEditableGroupMode, setIsEditableGroupMode] = useState(false);
  const [viewOptions, setViewOptions] = useState([]);
  // const [groupTableData, setGroupTableData] = useState([]);
  const [persmissionLevelOptions, setPermissionLevelOptions] = useState([]);
  const [updateCounter, setUpdateCounter] = useState(0);
  const [selectedDataToBeDeteted, setSelectedDataToBeDeleted] = useState(null);

  const [reactTableHeaderConfigData, setReactTableHeaderConfigData] = useState([]);
  const [reactTableBodyData, setReactTableBodyData] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedGroupMember, setSelectedGroupMember] = useState(false);
  const [isGroupMemberDrawerOpen, setIsGroupMemberDrawerOpen] = useState(false);

  const [selectedPermisionLevel, setSelectedPermissionLevel] = useState(null);
  const [errorFields, setErrorFields] = useState({ name: false, description: false });
  const [isApiLoading, setIsApiLoading] = useState(false);
  const [isApiError, setIsApiError] = useState(false);
  const [views, setViews] = useState([]);
  const [selectedValues, setSelectedValues] = useState([]);
  const data = useParams();
  const dispatch = useDispatch();

  // FORM VALIDATION --------------------------------------------------------------------------------------------
  const [formData, setFormData] = useState({
    name: null,
    description: null,
    permissionLevel: null,
    permissionLevelId: null,
  });
  const validationRules = {
    name: {
      required: true,
      errorMessage: "Name is required.",
    },
    description: {
      required: true,
      errorMessage: "Description is required.",
    },
    permissionLevel: {
      required: true,
      errorMessage: "Permission Level is required.",
    },
    views: {
      required: true,
      errorMessage: "Views is required.",
    },
  };
  const { values, errors, touched, handleChange, handleBlur, validateField, isFormValid } = useCustomFormValidation(
    formData,
    validationRules
  );
  // FORM VALIDATION --------------------------------------------------------------------------------------------

  const closeGroupDrawer = () => {
    setIsGroupDrawerOpen(false);
    setFormData({ name: null, description: null, permissionLevel: null, permissionLevelId: null, views_id: null });
    setIsEditableGroupMode(false);
    setSelectedValues([]);
  };

  const HEADER_CONFIG = [
    {
      accessor_key: "group_name",
      label: "Group Name",
      callingFunction: (item) => {
        getUserByGroup(item?.id);
        setSelectedGroup(item);
      },
    },
    {
      accessor_key: "description",
      label: "Descripton",
    },
    {
      accessor_key: "permission_level",
      label: "Permisson Level",
      callingFunction: (item) => {
        // setSelectedPermissionLevel(item);
        getPermissionsList(item?.permission_level_id);
      },
    },
  ];

  const HEADER_CONFIG_BY_GROUP_MEMBER = [
    {
      accessor_key: "name",
      label: "Name",
      callingFunction: (item) => {
        setSelectedGroupMember(item);
        setIsGroupMemberDrawerOpen(true);
      },
    },
    {
      accessor_key: "reporting_manager",
      label: "Report Manager",
    },
    {
      accessor_key: "department",
      label: "Department",
    },
    {
      accessor_key: "permission",
      label: "Permission",
    },
  ];

  const handleGroupFormSubmit = (e) => {
    e.preventDefault();
    const formValid = isFormValid();
    if (formValid) {
      console.log(formValid, formData);
    }
  };

  const handleFieldChange = (e) => {
    handleChange(e);
    const { name, value, label } = e.target;
    if (name === "permissionLevel") {
      setFormData((prevFormData) => ({ ...prevFormData, [name]: label, permissionLevelId: value }));
    }

    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
  };

  const fetchGroupData = async () => {
    try {
      setIsApiLoading(true);
      const groupDataResponse = await fetchManagePermission({
        query: {
          company_id: data?.id || getCompanyId(),
          key: "all_groups",
        },
      });

      if (groupDataResponse?.success) {
        setReactTableBodyData(
          groupDataResponse?.data?.map((data) => {
            return {
              description: data?.about_group,
              id: data?.group_id,
              ...data,
            };
          })
        );
      } else {
        setIsApiError(true);
        dispatch(
          pushAlert({
            visible: true,
            type: "danger",
            message: groupDataResponse?.message || "Failed to fetch group data",
          })
        );
      }
    } catch (error) {
      // UPDATE ERROR STATE
      setIsApiError(true);
      dispatch(
        pushAlert({
          visible: true,
          type: "danger",
          message: error?.message || "An error occurred while fetching group data",
        })
      );
    } finally {
      setIsApiLoading(false);
    }
  };

  const handleGroupAddUpdate = async (e) => {
    e.preventDefault();
    setIsApiLoading(true);
    try {
      let body = {
        company_id: data?.id || getCompanyId(),
        group_name: formData?.name,
        description: formData?.description,
        permission_level_id: formData?.permissionLevelId,
        group_owner: 0,
        views_id: formData?.views_id,
      };

      if (!formData?.name || !formData?.permissionLevelId) {
        setErrorFields({
          name: !formData?.name,
          description: !formData?.description,
          permissionLevel: !formData?.permissionLevelId,
        });
        dispatch(
          pushAlert({
            visible: true,
            type: "danger",
            message: "Mandatory fields are missing",
          })
        );
        return;
      }

      if (formData?.id) {
        body = {
          ...body,
          id: formData?.id,
        };
      }

      const response = await addUpdateGroup({ body });

      if (response?.success) {
        dispatch(
          pushAlert({
            visible: true,
            message: "Group Updated Successfully",
            type: "success",
          })
        );
        closeGroupDrawer();
        fetchGroupData();
      } else {
        dispatch(
          pushAlert({
            visible: true,
            type: "danger",
            message: response?.message,
          })
        );
        closeGroupDrawer();
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          type: "danger",
          message: error?.message,
        })
      );
      closeGroupDrawer();
    } finally {
      setIsApiLoading(false);
    }
  };

  const getPermissionLevelOptions = async () => {
    setIsApiLoading(true);
    const response = await fetchManagePermission({
      query: {
        company_id: data?.id || getCompanyId(),
        key: "permission",
      },
    });
    setPermissionLevelOptions(
      response?.data?.map((data) => {
        return {
          value: data?.permission_id,
          label: data?.permission_name,
        };
      })
    );

    setIsApiLoading(false);
  };

  const handleDeleteGroup = async (item) => {
    try {
      setIsApiLoading(true);
      const deleteGroupResponse = await deleteGroup({ body: { group_id: item?.id, company_id: item?.company_id } });
      if (deleteGroupResponse?.success) {
        dispatch(
          pushAlert({
            visible: true,
            message: "Group Deleted Successfully",
            type: "success",
          })
        );
        fetchGroupData();
      } else {
        dispatch(
          pushAlert({
            visible: true,
            type: "danger",
            message: deleteGroupResponse?.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          type: "danger",
          message: error?.message,
        })
      );
    } finally {
      setIsApiLoading(false);
    }
  };

  const handleDeleteGroupDialogConfirmation = async () => {
    setUpdateCounter((prevCounter) => prevCounter + 1);
    dispatch(
      pushAlert({
        type: "revert",
        message: "",
        visible: true,
        counter: updateCounter,
        onConfirm: () => {
          if (selectedGroup) {
            handleGroupMemberDelete(selectedDataToBeDeteted);
          } else {
            handleDeleteGroup(selectedDataToBeDeteted);
          }
          setSelectedDataToBeDeleted(null);
        },
        onRevert: () => {
          setSelectedDataToBeDeleted(null);
        },
      })
    );
  };

  const handleGroupMemberDelete = async (item) => {
    try {
      setIsApiLoading(true);
      const response = await deleteGroupPermission({
        body: {
          group_id: selectedGroup?.id,
          company_id: data?.id || getCompanyId(),
          group_member_id: item?.group_member_id,
        },
      });
      if (response?.success) {
        dispatch(
          pushAlert({
            visible: true,
            message: "Group Member Deleted Successfully",
            type: "success",
          })
        );
        getUserByGroup(selectedGroup?.id);
      } else {
        dispatch(
          pushAlert({
            visible: true,
            type: "danger",
            message: response?.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          type: "danger",
          message: error?.message,
        })
      );
    } finally {
      setIsApiLoading(false);
    }
  };

  const getPermissionsList = async (permission_id = null) => {
    setIsApiLoading(true);
    const permissionResponseData = await fetchManagePermission({
      query: {
        company_id: data?.id || getCompanyId(),
        key: "single_permission",
        permission_id,
      },
    });

    setSelectedPermissionLevel(
      permissionResponseData?.data?.map((data) => {
        return {
          ...data,
          name: data?.permission_name,
          description: data?.permission_description,
          organisationView: data?.modules,
        };
      })[0]
    );

    setIsApiLoading(false);
  };

  const getUserByGroup = async (group_id) => {
    try {
      setIsApiLoading(true);
      const response = await fetchManagePermission({
        query: {
          company_id: data?.id || getCompanyId(),
          key: "group_members",
          group_id: group_id || selectedGroup?.id,
        },
      });

      if (response?.success) {
        setReactTableBodyData(
          response?.data[0]?.members?.map((data) => {
            return {
              ...data,
              name: data?.name,
              reporting_manager: data?.reporting_manager_name,
              department: data?.department_name,
              permission: data?.permission_level_name,
            };
          })
        );
        setReactTableHeaderConfigData(HEADER_CONFIG_BY_GROUP_MEMBER);
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          type: "danger",
          message: error?.message,
        })
      );
    } finally {
      setIsApiLoading(false);
    }
  };

  const getViews = async () => {
    try {
      setIsApiLoading(true);
      const response = await fetchManagePermission({
        query: {
          company_id: data?.id || getCompanyId(),
          key: "all_views",
          // permission_id: id,
        },
      });

      if (response?.success) {
        setViewOptions(
          response?.data.map((item) => {
            return {
              label: item?.view_type_name,
              value: item?.id,
            };
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          type: "danger",
          message: error?.message,
        })
      );
    } finally {
      setIsApiLoading(false);
    }
  };

  const handleBackButtonClick = () => {
    setSelectedGroup(null);
    setReactTableHeaderConfigData(HEADER_CONFIG);
    fetchGroupData();
  };

  const handleAddIconClick = async () => {
    if (selectedGroup?.id) {
      setFormData({ name: null, description: null, permissionLevel: null, permissionLevelId: null, views_id: null });
      setIsGroupMemberDrawerOpen(true);
    } else {
      setIsGroupDrawerOpen(true);
    }
  };

  const handleCloseEditGroupMember = () => {
    setSelectedGroupMember({});
    setIsGroupMemberDrawerOpen(false);
  };

  useEffect(() => {
    getPermissionLevelOptions();
    fetchGroupData();
  }, []);

  useEffect(() => {
    setReactTableHeaderConfigData(HEADER_CONFIG);
  }, []);

  useEffect(() => {
    if (isApiLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [isApiLoading]);

  useEffect(() => {
    if (isGroupDrawerOpen) {
      getViews();
    }
  }, [isGroupDrawerOpen]);

  const handleMultiSelectChange = (event) => {
    const selected = event.target.value;
    const updated = viewOptions.filter((opt) => selected.includes(opt.value));
    setSelectedValues(updated);
    setFormData((prevFormData) => ({ ...prevFormData, views_id: updated.map((item) => item.value) }));
  };
  return (
    <>
      <div className="min-w-0 grow ">
        <ConfirmationDialogBox
          onConfirm={() => {
            setSelectedDataToBeDeleted(null);
            handleDeleteGroupDialogConfirmation();
          }}
          open={selectedDataToBeDeteted}
          onClose={() => setSelectedDataToBeDeleted(null)}
          message={"Do you want to delete this group?"}
          iconVariant={"delete"}
          confirmVariant="delete"
          confirmText="Delete"
          cancelText="Cancel"
        />

        {!selectedPermisionLevel ? (
          <ReactTableComponent
            tablename={<TabSwitch />}
            apiStates={{
              body: {
                isLoading: isApiError,
                isError: isApiError,
              },
            }}
            alternateDivs={{
              emptyData: (
                <div className="w-full h-full">
                  <div className="flex justify-center items-center flex-col space-y-2 h-full ">
                    <NoGroup className="w-[300px] h-[300px]" />
                    <span className="text-[#000000] font-poppins font-500 text-14">No Group is available</span>
                  </div>
                </div>
              ),
            }}
            // tablename={
            //   <p className="text-2C495D font-600">
            //     {selectedGroup?.group_name ? (
            //       <span onClick={handleBackButtonClick} className="cursor-pointer flex items-center gap-2">
            //         {" "}
            //         <BackArrow /> {` ${selectedGroup?.group_name}`}
            //       </span>
            //     ) : (
            //       "Groups"
            //     )}
            //   </p>
            // }
            headers={reactTableHeaderConfigData || []}
            body={reactTableBodyData || []}
            isHyperLinkBold
            actionField={
              <div className="flex items-center h-full">
                <div className="flex items-center ml-1 cursor-pointer">
                  <ToolTipComponent
                    text={selectedGroup?.id ? "Add Group Member" : "Add Group"}
                    style={{ color: "#1D4469" }}
                  >
                    <span
                      onClick={handleAddIconClick}
                      className="cursor-pointer border border-[#EBF2F6] rounded-md hover:bg-[#CECECE4D] hover:border-transparent"
                    >
                      <PlusIcon />
                    </span>
                  </ToolTipComponent>
                </div>
              </div>
            }
            actionColumn={(item) => {
              return (
                <div className="flex items-center gap-4">
                  {!selectedGroup?.group_name && (
                    <div
                      onClick={() => {
                        setIsGroupDrawerOpen(true);
                        setFormData({
                          name: item?.group_name,
                          description: item?.description,
                          permissionLevel: item?.permission_level,
                          permissionLevelId: item?.permission_level_id,
                          id: item?.id,
                          views_id: item?.views_id?.map((item) => item?.view_id),
                        });
                        setSelectedValues(
                          item?.views?.map((item) => ({ label: item?.view_name, value: item?.view_id }))
                        );
                        setIsEditableGroupMode(true);
                      }}
                    >
                      <PencilIcon />
                    </div>
                  )}
                  <button
                    onClick={() => {
                      setSelectedDataToBeDeleted(item);
                    }}
                  >
                    <DeleteIcon color={"red"} size={18} />
                  </button>
                </div>
              );
            }}
          />
        ) : (
          <>
            <PermissionModuleOptions
              formData={selectedPermisionLevel}
              setFormData={setSelectedPermissionLevel}
              setErrorFields={setErrorFields}
              refetchApi={fetchGroupData}
              onClose={() => setSelectedPermissionLevel(null)}
            />
          </>
        )}
      </div>

      {isGroupMemberDrawerOpen && (
        <EditGroupMember
          isOpen={isGroupMemberDrawerOpen}
          onClose={handleCloseEditGroupMember}
          selectedMember={selectedGroupMember}
          group_id={selectedGroup?.id}
          setIsApiLoading={setIsApiLoading}
          onSuccessSubmit={getUserByGroup}
        />
      )}

      {isGroupDrawerOpen && (
        <CustomDrawer open={isGroupDrawerOpen} onClose={closeGroupDrawer}>
          <div className="h-full flex flex-col">
            <div className="flex justify-between items-center h-1/12 px-4 py-4 border-b border-[#BECBD3]">
              <div className="text-[16px] font-poppins font-medium capitalize text-[#1D4469]">
                {formData && formData?.id ? "Update" : "Create"} Group
              </div>
              <div onClick={closeGroupDrawer} className="cursor-pointer">
                <CrossIcon />
              </div>
            </div>
            <form onSubmit={handleGroupFormSubmit} className="min-h-0 grow flex flex-col justify-between">
              <div className="min-h-5 p-4 flex flex-col gap-3">
                <div className="w-full flex flex-col">
                  <LabelComponent labelText="Name" isMandatory />
                  <InputComponent
                    mandatory={errors?.name}
                    value={formData?.name}
                    onChange={handleFieldChange}
                    name="name"
                    placeholder="Enter Name"
                  />
                </div>
                <div className="w-full flex flex-col">
                  <LabelComponent labelText="Description" isMandatory={false} />
                  <InputComponent
                    // mandatory={errors?.description}
                    value={formData?.description}
                    onChange={handleFieldChange}
                    name="description"
                    placeholder="Enter Description"
                  />
                </div>
                <div className="w-full flex flex-col">
                  <LabelComponent labelText="Permission Level" isMandatory={true} />
                  <BasicSelect
                    options={persmissionLevelOptions}
                    label="Permission Level"
                    onChange={handleFieldChange}
                    selectedOptions={persmissionLevelOptions?.filter(
                      (option) => option.value === formData?.permissionLevel
                    )}
                    value={formData?.permissionLevel}
                    type={"select"}
                    size={"medium"}
                    name="permissionLevel"
                    isError={errors?.permissionLevel}
                    showSearch
                  />
                </div>
                <div className="w-full flex flex-col">
                  <LabelComponent labelText="Views" />
                  <SelectComponent
                    name="views"
                    options={viewOptions}
                    value={selectedValues}
                    onChange={handleMultiSelectChange}
                    multiSelect={true}
                    placeholder="Select Views"
                  />
                </div>
              </div>
              <div className="flex justify-end gap-1 p-4 border-t border-[#BECBD3] shadow-md">
                <Button
                  onClick={() => {
                    closeGroupDrawer();
                  }}
                  variant={"secondary"}
                >
                  Cancel
                </Button>
                <Button onClick={handleGroupAddUpdate} type={"submit"} variant={"primary"}>
                  {formData && formData?.id ? "Update" : "Create"}
                </Button>
              </div>
            </form>
          </div>
        </CustomDrawer>
      )}
    </>
  );
};

export default Group;
